module.exports = __webpack_public_path__ + "feaa235ccd42396550a522105fd0d672.svg";